/**
 * This Middleware is used to filter calls for CEAP Users. 
 * Given any Engagement, If user is CEAP user then restrict to only GET calls
 * Action is filtered only if the user is CEAP user
 * API calls with method other than GET will not continue to next middleware
 * Exception: Certain POST endpoints that perform GET-like operations are allowed (configured in ceapUserWhitelistRoutes)
 */

import _ from 'lodash';
import Env from '../util/env';

const ceapUserMiddleware = (config) => (store) => (next) => (action) => {  
    const ceap_user = store.getState().userPreferences.isCEAPUser;

    if (_.isBoolean(ceap_user) && !ceap_user) {
        return next(action);
    }
    if (action.meta && action.meta.api && action.meta.api.method !== 'GET') {
        if (action.meta.api.method === 'POST' && Env.isCeapWhitelistedRoute(action.meta.api.url)) {
            return next(action);
        }
        return next({type: "WARNING_MESSAGE", message: "CEAP USER: CANNOT MODIFY"});
    }
    return next(action);
};

export default ceapUserMiddleware;
